import { API } from "./axiosInstance"

/**
 * Get all the latest versions of the documentation
 * @returns the documentation
 */
export const getDocumentation = async () => {
    const documentation = await API.get(`documentation`);
    return documentation.data;
}

/**
 * Get one document to download
 * @returns the document
 */
export const getDocument = async (id) => {
    const document = await API.get(`documentation/`+id, );
    return document.data;
}
